var BASE_USER_SETTINGS_KEY = 'userSettings';
var userSettingsKeys = {
  userSettings: [BASE_USER_SETTINGS_KEY]
};
export default userSettingsKeys;